/*
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-08-05 15:25:26
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-21 16:08:56
 * @FilePath: \惠宾官网\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import 'babel-polyfill'
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'

import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios'
// 引入jQuery、bootstrap
import $ from 'jquery'
import 'bootstrap'
// 引入bootstrap样式
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
// import '@/assets/js/swiper.animate1.0.3.min'
import 'windi.css'
import '@/filter/filter'
import http from "@/assets/http/http.js";
import VueAwesomeSwiper from 'vue-awesome-swiper';
import '@/assets/css/swiper.min.css';
import  "animate.css";
import "wowjs/css/libs/animate.css";
// import animated from 'animate.css';

import 'fullpage.js/dist/fullpage.css';
import "./utils/rem.js"; // 自适应分辨率
import platform from './utils/platform.js';
import '@/mock/index.js';

Vue.prototype.$http=http;
// 全局注册 $
Vue.prototype.$ = $;
Vue.prototype.$platform=platform;
Vue.config.productionTip = false
// Vue.use(animated)

Vue.use(VueCompositionAPI)
Vue.use(VueAwesomeSwiper);
new Vue({
  router,
  store,
	$,
  render: h => h(App),
	created: function() {
	},
}).$mount('#app')
